import React, { useState, useEffect } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import { saveDiscountSvc } from './DiscountSvc';

const DiscountSlider = (props) => {
    const [discountId, setDiscountId] = useState(props.discountObj.discountId)
    const [loader, setLoader] = useState(props.loader)
    const [discountLabel, setDiscountLabel] = useState(props.discountObj.discountLabel || '')
    const [remarksMandatory, setRemarksMandatory] = useState(!!props.discountObj.remarksMandatory)

    function handleLabelChange(param) {
        setDiscountLabel(param)
    }
    function handleRemarksMandatoryChange(param) {
        setRemarksMandatory(param)
    }
    function saveDiscount(e) {
        const objDiscount = {
            discountId: discountId,
            discountLabel: discountLabel,
            remarksMandatory: remarksMandatory ? 1 : 0
        }
        setLoader("block")
        props.closeSlider()
        props.generateRandomNo()
        saveDiscountSvc(objDiscount, cbSaveDiscountResponse);
    }
    function cbSaveDiscountResponse(data) {
        setLoader("none")
        if (data.SvcStatus === "Success") {
            toast.success(data.SvcMsg)
            setLoader('none')
            props.generateRandomNo()
        } else {
            toast.error(data.SvcMsg)
            setLoader('none')
        }
    }
    useEffect(() => {
        setDiscountId(props.discountObj.discountId)
        setDiscountLabel(props.discountObj.discountLabel || '')
        setRemarksMandatory(!!props.discountObj.remarksMandatory)
    }, [])

    return (
        <form className='form form-horizontal' style={{ pointerEvents: loader === "none" ? "auto" : "none", height: '100%', width: '100%', margin: '0 auto', marginTop: 40, background: '#fff', border: '1px solid #ccc', borderRadius: 10 }}>
            <div style={{ position: 'fixed', zIndex: 10000, width: 100, height: 100, marginLeft: -50, marginTop: -50, left: '50%', top: '50%', display: loader }}>
                <img className="loderImg" src={require("common/images/loader.gif")} alt="Loader..." />
            </div>
            <button type="button" className='btn btn-info text-center btnCloseDiv' onClick={props.closeSlider}>
                <span id="close" title="Close Slider" className="glyphicon glyphicon-remove"></span>
            </button>
            <div className='row'>
                <div className="form-group col-md-6">
                    <label className="control-label col-sm-5">Discount ID</label>
                    <div className='col-sm-6 padding-remove'>
                        <input
                            type="text"
                            defaultValue={discountId}
                            className="form-control"
                            readOnly
                        ></input>
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className="form-group col-md-6">
                    <label className="control-label col-sm-5">Label</label>
                    <div className='col-sm-6 padding-remove'>
                        <input
                            type='text'
                            className="form-control"
                            maxLength={20}
                            value={discountLabel}
                            onChange={(e) => handleLabelChange(e.target.value)}
                        />
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className="form-group col-md-6">
                    <label className="control-label col-sm-5">Remarks Mandatory</label>
                    <div className='col-sm-6 padding-remove'>
                        <input
                            type='checkbox'
                            className="form-control"
                            checked={remarksMandatory}
                            onChange={(e) => handleRemarksMandatoryChange(e.target.checked)}
                        />
                    </div>
                </div>
            </div>

            <div className="col-md-12">
                <div className="col-md-6">
                    <div className="col-md-11 padding-remove">
                        <button type="button" className="btn btn-info btn-space pull-right" onClick={(e) => saveDiscount(e)}>Save</button>
                    </div>
                </div>
            </div>
        </form>
    );
};
export default DiscountSlider;
